module.exports = __webpack_public_path__ + "img/down.ea0f0f96.png";